import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class EduPage extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { eduPage,currentEdu} = this.props.system;
     this.fetchList( eduPage);
  }

  fetchList = (page,values) => {
    const {getEduList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getEduList(params);
  }

  getDataSource() {
    const { system } = this.props;
    const { eduById, eduList } = system;
    if (!eduList) return [];
    return eduList.map(id => eduById[id]);
  }

  get listProps() {
    const { system,actions } = this.props
    const { getEduListPending,eduTotal,eduPage } = system
    const { deleteEdu,chooseCurrentEdu,eduModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getEduListPending,
      columns:[
        {
          title: "id",
          dataIndex: 'id',
          key: 'id',
          width: 180,
        },
        {
          title: "学历名称",
          dataIndex: 'name',
          key: 'name',
          width: 180,
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',
          width: 180,
        },
      ],
      pagination:{
        total:eduTotal,
        current:eduPage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentEdu(record);
          eduModalChange(true,"updata");
        }else if(item.key == 3){
            deleteEdu(record.id).then((data) => {
            this.fetchList(eduPage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { system,actions } = this.props
    const { currentEdu, eduModalVisible,eduPage, eduModalType,submitEduPending } = system

    const { eduModalChange,submitEdu } = actions;
    const editItem  = eduModalType === 'create' ? {} : currentEdu
    return {
      item: eduModalType === 'create' ? {} : currentEdu,
      visible: eduModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitEduPending,
      title: `${
        eduModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "name",
          label: "学历名称",
          initialValue: editItem.name,
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitEdu(Object.assign({},data,{})).then(data=> {
          eduModalChange(false,"create");
          this.fetchList(eduPage);
        })
      },
      onCancel() {
        eduModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,system } = this.props
    const { currentEdu,eduPage} = system
    const { eduModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "name",
            widget: Input,
            widgetProps:{
                placeholder:"请输入学历名称"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        eduModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,system } = this.props
    const { currentEdu,eduPage} = system
    const { eduModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ eduModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EduPage);


// WEBPACK FOOTER //
// ./src/features/system/EduPage.js